module.exports = __webpack_public_path__ + "img/anas-no-bg.3f3df726.png";